import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Ruler = function Ruler(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m14.5 5.4999 1.5 1.5m-4.5 1.5 1.5 1.5m-4.5 1.5 1.5 1.5m-4.5 1.5 1.5 1.5m-4.4344 1.5657 3.8686 3.8686c.198.198.297.2971.4112.3341a.5.5 0 0 0 .309 0c.1142-.037.2132-.1361.4112-.3341L21.4342 7.5656c.198-.198.2971-.297.3341-.4112a.5.5 0 0 0 0-.309c-.037-.1141-.1361-.2131-.3341-.4112l-3.8686-3.8686c-.198-.198-.297-.297-.4112-.3341a.5.5 0 0 0-.309 0c-.1141.0371-.2132.1361-.4112.3341L2.5656 16.4342c-.198.198-.297.2971-.3341.4112a.5.5 0 0 0 0 .309c.0371.1142.1361.2132.3341.4112"
    })
  }));
};
export default Ruler;